import React from 'react';

interface LoadingProps {
  variant?: 'fullscreen' | 'default';
  width?: number;
  color?: string;
}

const LoadingDots: React.FC<LoadingProps> = () => (
  <div className="snippet">
    <div className="stage">
      <div className="dot-flashing" />
    </div>
  </div>
);

export default LoadingDots;
